<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      :max-width="options.width"
      @keydown.esc="cancel()"
    >
      <v-toolbar
        v-show="!!title"
        dark
        :color="options.color"
        dense
      >
        <v-toolbar-title class="white--text">
          {{ title }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card tile>
        <v-card-text
          v-show="!!message"
          class="pt-4"
          style="min-height:75px"
        >
          {{ message }}
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            id="confirm_no"
            color="error"
            @click.native="cancel()"
          >
            No
          </v-btn>
          <v-btn
            id="confirm_yes"
            color="success"
            @click.native="agree()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="openInfoDialog"
      :max-width="options.width"
      @keydown.esc="cancel()"
    >
      <v-toolbar
        v-show="!!title"
        dark
        :color="options.color"
        dense
      >
        <v-toolbar-title class="white--text">
          {{ title }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card tile>
        <v-card-text
          v-show="!!message"
          style="min-height:75px"
        >
          {{ message }}
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            id="info_no"
            color="error"
            @click.native="cancel()"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/**
 *
 * Insert component where you want to use it:
 * <confirm ref="confirm"></confirm>
 *
 * Call it:
 * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {});
 *
 * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
 * <template>
 *   <v-app>
 *     ...
 *     <confirm ref="confirm"></confirm>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$confirm = this.$refs.confirm.open;
 * }
 */
export default {
	data() {
		return {
			dialog: false,
			openInfoDialog: false,
			resolve: null,
			message: null,
			title: null,
			options: {
				color: "error",
				width: 350
			}
		};
	},
	methods: {
		open(title, message, options) {
			this.dialog = true;
			this.title = title;
			this.message = message;
			this.options = Object.assign(this.options, options);
			return new Promise(resolve => {
				this.resolve = resolve;
			});
		},
		openInfo(title, message, options) {
			this.openInfoDialog = true;
			this.title = title;
			this.message = message;
			this.options = Object.assign(this.options, options);
			return new Promise(resolve => {
				this.resolve = resolve;
			});
		},
		agree() {
			this.resolve(true);
			this.dialog = false;
		},
		cancel() {
			this.resolve(false);
			this.dialog = false;
			this.openInfoDialog = false;
		}
	}
};
</script>